export interface LimitIntervalDTO {
  code: string;
  description: string;
  detailedDescription: object;
  defaultRenewalOn: string;
  defaultRenewalPeriod: number;
  enabled: boolean;
  createdOn: string;
  updatedOn: string;
}

export enum LimitIntervalCodesEnum {
  SUPPLY = 'SUPPLY',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}
